import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useAppContext } from '../../appProvider/contextProvider';
import { changeCard, getCardDetails, upgradeSubscription } from '../../services/stripe';
import { viewPrivacyPolicy, viewTermsAndCondition } from '../../Util/TermsAndPrivacy';


const ChangePlan = () => {

    const { setChangePlanPopupOpen, 
        isFetching, 
        chosenPlan, 
        setPricingPopupOpen, 
        refetchProfile, 
        refetchFeatures,
        setUpdatePlanSuccess,
        setUpdatePlanFailure,
        refetchWebsites
    } = useAppContext();
    const [cardDetails, setCardDetails] = useState(null);
    const [paymentMethod, setPaymentMethod] = useState('default');

    useQuery('fetchCardDetails', getCardDetails, {
        onSuccess: (cards) => {
            if(cards.error) {

            } else {
                setCardDetails(cards);
            }
        }
    })

    const goBack = () => {
        setChangePlanPopupOpen(false);
        setPricingPopupOpen(true);
    }

    const getMonth = (month) => {
        if(month < 10) return `0${month}`;
        return month;
    }

    const upgrade = useMutation(() => {
        return upgradeSubscription(chosenPlan?.price_id);
    }, {
        onSuccess: async (data) => {
            if(data.errors) {
                setUpdatePlanFailure(true);
            } else {
                await refetchProfile();
                await refetchFeatures();
                await refetchWebsites();
                setUpdatePlanSuccess(true);
            }
            setChangePlanPopupOpen(false);
            
        }
    });

    const change = useMutation(() => {
        return changeCard();
    }, {
        onSuccess: ({url}) => {
            if(url) {
                window.open(url);
            }
        }
    });

    const update = (event) => {
        event.preventDefault();
        if(paymentMethod === 'new') {
            change.mutate();
        } else {
            upgrade.mutate();
        }
    }

    const cancel = () => {
        setChangePlanPopupOpen(false);
    }

    return !isFetching && <><div className="modal fade show" tabindex="-1">
    <div className="modal-dialog ">
        <div className="modal-content">
            <div className="modal-body p-5">
                <h3 className="mt-3">Verify payment method</h3>
                <p className="mb-5">Select a payment method to use with your { chosenPlan?.type === 'subscriber-based' ? 'Subscriber' : 'Impression'} Based Plan.</p>
                <div className="d-flex align-items-center mb-3">
                    <div className="custom-control custom-radio mr-3">
                        <input 
                            type="radio" 
                            id="customRadio6" 
                            name="customRadio" 
                            className="custom-control-input" 
                            checked={paymentMethod === 'default'}
                            onChange={() => setPaymentMethod('default') }
                        />
                        <label className="custom-control-label d-flex align-items-center titleCase" for="customRadio6">
                            {/* <img src="images/download.png" className="card-placeholder" alt="Card Image"/> */}
                            <i>{cardDetails?.brand}</i>&nbsp;&nbsp;*****{cardDetails?.last4}<span className="badge">Default</span>
                        </label>
                    </div>
                    <p className="ml-auto">Expires {getMonth(cardDetails?.exp_month)}/{cardDetails?.exp_year}</p>
                </div>
                {/* <div className="custom-control custom-radio mr-3">
                    <input 
                        type="radio" 
                        id="customRadio7"
                        name="customRadio" 
                        className="custom-control-input" 
                        checked={paymentMethod === 'new'}
                        onChange={() => setPaymentMethod('new') }
                    />
                    <label className="custom-control-label d-flex align-items-center" for="customRadio7">
                        Add payment method
                    </label>
                </div> */}
                <button className="btn btn-block btn-primary mt-5 mb-2" onClick = {update} >Update Your Plan</button>
                <button className="btn btn-block btn-outline mb-3" onClick={goBack} >View other plans</button>
                <button className="btn btn-block btn-danger mb-3" onClick={cancel} >Cancel</button>
                <p className="mb-4"><small>You can review important information from ChirpyWeb's <b onClick={viewTermsAndCondition} className="terms-link">Terms of Service</b> and <b onClick={viewPrivacyPolicy} className="terms-link">Privacy Policy</b> pages.</small></p>
            </div>
        </div>
    </div>
</div>
<div className="modal-backdrop fade show"></div>
</>

}

export default ChangePlan;